// Generic to every card operation — the entity being searched is carried by the operation's kind.
export const START_OPERATION = '[CustomerCard] Start Operation';
export const CONTINUE_OPERATION = '[CustomerCard] Continue Operation';
export const BACK = '[CustomerCard] Back';
export const CANCEL_CARD_OPERATION = '[CustomerCard] Cancel Operation';
export const SEARCH_REQUEST = '[CustomerCard] Search Request';
export const SEARCH_SUCCESS = '[CustomerCard] Search Success';
export const SEARCH_FAILURE = '[CustomerCard] Search Failure';
export const SELECT_SEARCH_RESULT = '[CustomerCard] Select Search Result';
export const CLEAR_SEARCH_RESULTS = '[CustomerCard] Clear Search Results';
